import { createFileRoute } from "@tanstack/react-router";
import tenantAxiosInstance from "api/tenantAxiosInstance";
import { useGetDefaultsQuery } from "api/TenantSlug/Setting/hooks.ts";
import { AdvertiserRegistrationForm } from "components/Forms/AdvertiserRegistrationForm/AdvertiserRegistrationForm.tsx";
import { AuthPageContainer } from "components/UI/AuthPageContainer/AuthPageContainer.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";

export const Route = createFileRoute("/$tenantSlug/auth/_layout/registration-advertiser/")({
    component: TenantAdvertiserRegistrationPage,
});

function TenantAdvertiserRegistrationPage() {
    const { t: tAuth } = usePaldockTranslation("auth.registration");
    const { t: tC } = usePaldockTranslation("common");
    const { tenantSlug } = Route.useParams();
    const getTenantQuery = useGetDefaultsQuery(tenantSlug);

    if (getTenantQuery.data?.tenant) {
        tenantAxiosInstance.setTenantSlugInUrl(getTenantQuery.data.tenant.slug_name);
    }

    return (
        <AuthPageContainer title={tAuth("title")}>
            {getTenantQuery.isSuccess ? (
                <AdvertiserRegistrationForm tenant={getTenantQuery.data.tenant} />
            ) : (
                tC("loading")
            )}
        </AuthPageContainer>
    );
}
